export default "__VITE_PUBLIC_ASSET__f233e5c1__"